export const BLOGS_ARTICLE_MENU_MORE = "blogs-article-menu-more";
